import StaticCrumb from '../components/StaticCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const teamRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/team',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: { label: 'Team', isCurrentPage: true },
        },
    ],
};
